export default __webpack_public_path__ + "static/media/App.a4f451af.svg";